import * as React from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CommandResult, errorCodes } from '../../amorg-common';
import { logout } from '../../api/authClientApi';
import { confirmNewEmail } from '../../api/userClientApi';
import { SingleColumnLayout } from '../_layouts/SingleColumnLayout';
import { MessageCard } from '../../designSystem/MessageCard';
import { PageHeader } from '../../designSystem/PageHeader';
import { P } from '../../designSystem/typography/Body';
import { clientAccessHelper } from '../../utils/clientAccessHelper';
import { ProtectedPageContext } from '../_contexts/ProtectedPageContext';
import { UserPageWrapper } from '../_pageWrappers/UserPageWrapper';

export default function ConfirmNewEmailPage(): JSX.Element {
    return (
        <UserPageWrapper breadCrumbs={[{ text: 'Bekræft ny e-mail addresse', url: '' }]}>
            <ConfirmNewEmailPageContent />
        </UserPageWrapper>
    );
}

function ConfirmNewEmailPageContent(): JSX.Element {

    const [result, setResult] = React.useState<CommandResult | undefined>(undefined);
    const params = useParams<{ siteId: string, userId: string, requestId: string }>();

    const activeUser = React.useContext(ProtectedPageContext).user;
    const hasAccess = clientAccessHelper.hasAllPermissions(activeUser, ['EditUser']);

    useEffect(() => {
        const getData = async () => {
            const result = await confirmNewEmail(params.siteId, params.userId, params.requestId);
            setResult(result);
            if (result.isSuccess) {
                await logout();
            }
        };
        getData();
    }, []);

    if (!hasAccess)
        return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

    return (
        <>
        <PageHeader headerText="Bekræft ny e-mail addresse" narrow />
        <SingleColumnLayout narrow>
            <>
        
                {result &&
                    <Result value={result as CommandResult} />
                }
            </>
        </SingleColumnLayout>
        </>
    );
}

type ResultProps = { value: CommandResult }
function Result({ value: result }: ResultProps): JSX.Element {
    const messageType = result.isSuccess ? 'success' : 'error';
    return (
        <>
            {result.isSuccess
                ? <MessageCard variant={messageType}>Din e-mail addresse er ændret. Log ind for at tage den i brug.</MessageCard>
                : getErrorMessage(result.errorMessage)
            }
        </>
    );

    function getErrorMessage(error: errorCodes) {
        switch (error) {
            case 'invalid_site':
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
            case 'confirmNewUserEmail_invalid_requestId':
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
            case 'confirmNewUserEmail_invalid_userId':
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
            case 'confirmNewUserEmail_no_requests_exist':
                return <MessageCard variant={'error'}>Linket er ikke længere gyldigt. Du kan oprette en ny ændring fra profil menuen.</MessageCard>
            case 'confirmNewUserEmail_email_in_use':
                return <MessageCard variant={'error'}>Den valgte e-mail er allerede i brug.  Du kan oprette en ny ændring fra profil menuen.</MessageCard>
            default:
                return <MessageCard variant={'error'}>Linket er ikke gyldigt. Kontakt amorg support.</MessageCard>
        }
    }
}